export default __webpack_public_path__ + "static/media/trash.96102d61.svg";